import auth_img1 from "../../images/help/authentication/platform-registeration-link.png"
import auth_img2 from "../../images/help/authentication/platform-registeration-page.png"
import auth_img3 from "../../images/help/authentication/business-register.png"
import auth_img4 from "../../images/help/authentication/loginpage.png"
import auth_img5 from "../../images/help/authentication/consent.png"
import zapier_img1 from '../../images/help/authentication/zapier/zapier-login-email.png'
import zapier_img2 from '../../images/help/authentication/zapier/zapier-dashboard.png'
import zapier_img3 from '../../images/help/authentication/zapier/zapier-assets-page.png'
import zapier_img4 from '../../images/help/authentication/zapier/zapier-editor.png'
import zapier_img5 from '../../images/help/authentication/zapier/zapier-referus-search.png'
import zapier_img6 from '../../images/help/authentication/zapier/refer-us-select-action.png'
import zapier_img7 from '../../images/help/authentication/zapier/login-success.png'
import zapier_img8 from '../../images/help/authentication/zapier/zapier-account-connected.png'
import zapier_img9 from '../../images/help/authentication/zapier/get-rewards-test.png'
import zapier_img10 from '../../images/help/authentication/zapier/get-rewards-response.png'
import zapier_img11 from '../../images/help/authentication/zapier/connect-new-acccount.png'
import zapier_img12 from '../../images/help/authentication/zapier/mailzimp-new-subscriber.png'
import zapier_img13 from '../../images/help/authentication/zapier/mailzimp-dashboard.png'
import zapier_img14 from '../../images/help/authentication/zapier/new-member-sign-up.png'
import zapier_img15 from '../../images/help/authentication/zapier/RR-get-reward-to-pay-referral.png'
import zapier_img16 from '../../images/help/authentication/zapier/RR-referral-added.png'
import zapier_img17 from '../../images/help/authentication/zapier/update-referral-status.png'
import zapier_img18 from '../../images/help/authentication/zapier/get-reward-to-pay-referral.png'
import zapier_img19 from '../../images/help/authentication/zapier/referral-rock-new-member-trigger.png'
import zapier_img20 from '../../images/help/authentication/zapier/rr-trigger-data.png'



export const authentication = [
    auth_img1 ,
    auth_img2,
    auth_img3,
    auth_img4,
    auth_img5,
]

export const zapier_authentication = [
    zapier_img1,
    zapier_img2,
    zapier_img3,
    zapier_img4,
    zapier_img5,
    zapier_img6,
    zapier_img7,
    zapier_img8,
    zapier_img9,
    zapier_img10,
    zapier_img11,
    zapier_img12,
    zapier_img13,
    zapier_img14,
    zapier_img15,
    zapier_img16,
    zapier_img17,
    zapier_img18,
    zapier_img19,
    zapier_img20
]
